module.exports = __webpack_public_path__ + "img/网报支付.7b53857a.png";